import {
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View
} from 'react-native'

// styles
import { globalStyles } from '../../../static/styles/global'

// components
import ModalPopup from './ModalPopup'
import CustomButton from '../button/Button'

interface modalConfirmProps {
  title: string
  message: string
  action?: any
  visible: boolean
  setVisible: any
}

const ModalConfrim = ({
  title,
  message,
  action,
  visible,
  setVisible
}: modalConfirmProps): JSX.Element => {
  return (
    <ModalPopup visible={visible}>
      <View style={[styles.body]}>
        <View style={[globalStyles.mb5]}>
          <Text
            style={[
              globalStyles.text,
              globalStyles.fs18,
              globalStyles.fwBold,
              globalStyles.mb1,
              globalStyles.textCenter
            ]}
          >
            {title}
          </Text>
          <Text style={[globalStyles.text, globalStyles.textCenter]}>
            {message}
          </Text>
        </View>
        <CustomButton text={'Next'} onPress={action} />
      </View>
    </ModalPopup>
  )
}

const styles = StyleSheet.create({
  body: {
    paddingTop: 30,
    paddingBottom: 40,
    paddingHorizontal: 20
  }
})

export default ModalConfrim
